import React from 'react';
import Modal from 'react-modal';
import { Container } from './styles';

interface Props {
  show: boolean;
}

const modalStyle = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    borderRadius: '8',
    background: 'rgba(0,0,0,0)',
    border: 'none',
    padding: '-100px',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

// eslint-disable-next-line react/prop-types
const UnioRedirectPopup: React.FC<Props> = ({ show }) => {
  return (
    <Modal
      isOpen={show}
      style={modalStyle}
      overlayClassName="Overlay"
      shouldCloseOnOverlayClick={false}
      shouldCloseOnEsc={false}
    >
      <Container>
        <h1>GPS agora é Unio!</h1>
        <p>
          O Portal Stone será descontinuado e não receberá mais atualizações.
          Para se manter atualizado e aproveitar as novas funcionalidades acesse o portal Unio.
        </p>
        <div>
          <button
            type="button"
            id="unio-portal-btn"
            onClick={() => {
              window.location.href = 'https://unio.stone.com.br';
            }}
          >
            Acessar o portal Unio
          </button>
        </div>
      </Container>
    </Modal>
  );
};

export default UnioRedirectPopup;
